import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setRenewalData } from '../../store/reducers/myPlansReducer';
import { setNavigationData } from '../../store/reducers/claimReducer';

const PlanActions = ({ids, assistNos, userIds, planData}) => {

    const dispatch = useDispatch();
    const assistNo = planData?.plan?.assistance_number || '';
    const id       = planData?.plan?.subscription_id || 0;
    const userId   = planData?.userId

    console.log("PlanActionsassistNo",assistNo);
    console.log("PlanActionsid",id);
    console.log("PlanActionsuserId",userId);
    console.log("planData",planData);
    const navigate = useNavigate();

    const handleRaiseClaimClick = () => {
    navigate('/raise-claim', { state: { id } });
    };

    const handleTrackClaimClick = () => {
        if(userId){
            localStorage.setItem('trackUserd',JSON.stringify(userId));
        }
        dispatch(setNavigationData({ assistNo, userId }));
        // navigate('/track-claim', { state: { assistNo, userId } });
        navigate('/track-claim');
    };

    const handleRenewal = () => {
        dispatch(setRenewalData({ id, userId }));
        navigate('/customer-profile');
    };

  return (
    <div className="plan-actions">
        {planData?.plan?.is_expired
            ? 
                <div className='btn-section'>
                    <button 
                        className='download-certificate-button'
                        onClick={handleRenewal}
                    >
                        Renew Plan
                    </button>
                </div>
        : 
                <div className='raiseclaim-trackclaim'>
                    <div className='btn-section'>
                        <button 
                            className='download-certificate-button'
                            onClick={handleRaiseClaimClick}
                        >
                            Raise a Claim
                        </button>
                    </div>
                    {assistNo && (
                        <button className="track-claim"
                                onClick={handleTrackClaimClick}
                            >
                            Track Claim
                        </button>
                    )}
                </div>
        }

    </div>
  );
};

export default PlanActions;